<div class="sam-form-flex-row sam-center sam-full-width sam-margin-top">
   <fa-icon
      [icon]="icon"
      [ngClass]="
         value !== valueOriginal
            ? 'sam-margin-left sam-margin-right sam-accent-color'
            : 'sam-margin-left sam-margin-right'
      "
   ></fa-icon>

   <kendo-dropdownlist
      class="sam-full-width sam-margin-right"
      [data]="orgdata"
      [value]="selectedEntry()"
      (selectionChange)="selectionChange($event)"
      [disabled]="isDisabled"
      valueField="id"
      textField="id"
   >
      <ng-template kendoAutoCompleteItemTemplate kendoDropDownListValueTemplate let-dataItem>
         <div class="sam-form-flex-row">
            <div *ngIf="dataItem?.orgnum !== null">{{ dataItem?.orgnum }}</div>
            <div *ngIf="dataItem?.orgnum !== null && dataItem?.id > 0" class="sam-margin-left sam-margin-right">·</div>
            <div>{{ dataItem?.orgnam }}</div>
         </div>
      </ng-template>
   </kendo-dropdownlist>

   <div style="min-width: 20%">
      <div class="sam-form-flex-row" style="align-items: center">
         <div class="sam-margin-left sam-margin-right sam-opacity-medium sam-base-font-size">·</div>
         <div class="sam-opacity-medium sam-sub-font-size">{{ orgUnit }}</div>
      </div>
   </div>
</div>

<div *ngIf="isComparatorActive" class="sam-form-flex-row sam-full-width sam-center">
   <fa-icon [icon]="icon" class="sam-margin-left sam-margin-right sam-opacity-off"></fa-icon>
   <div class="sam-form-flex-row sam-full-width">
      <div class="border-box k-bg-warning sam-full-width">
         <div class="sam-margin-left-medium sam-full-width sam-opacity-light sam-form-flex-row">
            <div *ngIf="updatedEntry()?.orgnum !== null">{{ updatedEntry()?.orgnum }}</div>
            <div
               *ngIf="updatedEntry()?.orgnum !== null && updatedEntry()?.id > 0"
               class="sam-margin-left sam-margin-right"
            >
               ·
            </div>
            <div>{{ updatedEntry()?.orgnam }}</div>
         </div>
      </div>
      <button kendoButton (click)="takeOtherClick()" primary="true" class="sam-margin-left">
         <div class="sam-button-text">
            {{ 'common.apply' | translate }}
         </div>
      </button>
   </div>
   <div class="sam-margin-right" style="min-width: 20%">
      <div class="sam-form-flex-row" style="align-items: center">
         <div class="sam-margin-left sam-margin-right-large sam-opacity-off">·</div>
         <div class="sam-opacity-ligth sam-sub-font-size sam-warning sam-italic">
            {{ 'brick.brick_definitions.directory_browser.edit_contact_details.updated_value' | translate }}
         </div>
      </div>
   </div>
</div>
